(() => {
  if (customElements.get('jeff-pair-combo')) return;

  class JeffPairCombo extends HTMLElement {
    constructor() {
      super();
      this.currentTier = 1;
      this.slots = {
        1: null,
        2: null,
        3: null
      };
      this.activePickerSlot = 2;
      this.lastPickerTrigger = null;
      this.previousBodyOverflow = '';
      this.previousBodyPosition = '';
      this.previousBodyTop = '';
      this.previousBodyLeft = '';
      this.previousBodyRight = '';
      this.previousBodyWidth = '';
      this.previousScrollY = 0;
      this.previousHtmlModalOpen = false;
      this.previousBodyModalOpen = false;
      this.modalItemsInitialized = false;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Elements
      this.tierButtons = this.querySelectorAll('[data-tier]');
      this.submitBtn = this.querySelector('[data-combo-submit]');
      this.submitText = this.querySelector('[data-combo-submit-text]');
      this.actionWrap = this.querySelector('[data-combo-action-wrap]');
      this.feedbackEl = this.querySelector('[data-combo-feedback]');
      this.modal = this.querySelector('.jeff-modal--combo-picker');

      // Slot 1 initial state
      const initialVariantId = parseInt(this.dataset.currentVariantId, 10) || null;
      const initialPrice = parseInt(this.dataset.currentPrice, 10) || 0;
      const initialUrl = this.dataset.productHandle ? `/products/${this.dataset.productHandle}` : window.location.pathname;
      this.slots[1] = {
        id: initialVariantId,
        title: this.dataset.productTitle || '',
        variant: this.getSlot1VariantText(),
        price: initialPrice,
        url: initialUrl
      };

      this.bindEvents();
      this.calculateTierPrices();
      this.updateUI();
      this.mountModal();
    }

    mountModal() {
      if (!this.modal || this.modal.parentElement === document.body) return;
      this.modal.dataset.comboModalOwner = this.id;
      document.body.append(this.modal);
    }

    getSlot1VariantText() {
      const mainEl = this.closest('jeff-product-main') || document.querySelector('jeff-product-main');
      if (!mainEl) return '';
      const color = mainEl.dataset.selectedColor || '';
      const size = mainEl.dataset.selectedSize || '';
      const parts = [];
      if (color) parts.push(color);
      if (size) parts.push(`Talla ${size}`);
      return parts.join(' · ') || 'Selecciona tu talla';
    }

    bindEvents() {
      // Tier Selection (1, 2, 3)
      this.tierButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const tier = parseInt(btn.dataset.tier, 10);
          if (this.currentTier === tier) {
            // Already selected: re-open picker if slots are not complete
            if (tier >= 2 && !this.slots[2]?.id) {
              this.openPickerModal(2);
              return;
            }
            if (tier === 3 && !this.slots[3]?.id) {
              this.openPickerModal(3);
              return;
            }
          }
          this.setTier(tier);
        });
      });

      // Slot 1: Click en tarjeta o "Cambiar" -> Smooth scroll to main product option picker
      this.querySelectorAll('[data-pair-slot="1"]').forEach(card => {
        card.addEventListener('click', (e) => {
          if (e.target instanceof Element && e.target.closest('a')) return; // Allow product title and thumbnail links to navigate
          e.preventDefault();
          const picker = document.querySelector('.jeff-block--variants') || document.querySelector('[data-jeff-size-button]');
          if (picker) {
            picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const firstAvailableSize = picker.querySelector('[data-jeff-size-button]:not(:disabled)');
            if (firstAvailableSize) firstAvailableSize.focus({ preventScroll: true });
          }
        });
      });

      // Slot 2 & Slot 3 cards: click anywhere on card (outside link) opens picker modal
      this.querySelectorAll('[data-pair-card="2"]').forEach(card => {
        card.addEventListener('click', (e) => {
          if (e.target instanceof Element && e.target.closest('a')) return;
          e.preventDefault();
          this.openPickerModal(2);
        });
      });

      this.querySelectorAll('[data-pair-card="3"]').forEach(card => {
        card.addEventListener('click', (e) => {
          if (e.target instanceof Element && e.target.closest('a')) return;
          e.preventDefault();
          this.openPickerModal(3);
        });
      });

      // Add Slot Triggers (+ AÑADIR SEGUNDO / TERCER PAR)
      this.querySelectorAll('[data-pair-add], [data-pair-change]:not([data-pair-change="1"])').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const slot = parseInt(btn.dataset.pairAdd || btn.dataset.pairChange, 10);
          this.openPickerModal(slot);
        });
      });

      // Modal Close Triggers
      if (this.modal) {
        this.modal.querySelectorAll('[data-combo-picker-close]').forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.closePickerModal();
          });
        });
        this.modal.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.closePickerModal();
            return;
          }
          if (e.key === 'Tab') {
            this.trapModalFocus(e);
          }
        });
      }

      // Modal items are initialized on-demand or during idle time to prevent blocking INP
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => this.initModalItems(), { timeout: 3500 });
      } else {
        setTimeout(() => this.initModalItems(), 2000);
      }

      // Combo Submit Button
      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.currentTier >= 2 && !this.slots[1]?.id) {
            const picker = document.querySelector('.jeff-block--variants') || document.querySelector('[data-jeff-size-button]');
            if (picker) {
              picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
              const firstSize = picker.querySelector('[data-jeff-size-button]:not(:disabled)');
              if (firstSize) firstSize.focus({ preventScroll: true });
            }
            return;
          }
          if (this.currentTier >= 2 && !this.slots[2]?.id) {
            this.openPickerModal(2);
            return;
          }
          if (this.currentTier === 3 && !this.slots[3]?.id) {
            this.openPickerModal(3);
            return;
          }
          this.handleComboSubmit(e);
        });
      }

      // Sincronización con cambios de variante del producto principal
      this.variantListener = (e) => {
        const detail = e.detail;
        if (!detail) return;
        if (this.dataset.productId && String(detail.productId) !== String(this.dataset.productId)) return;

        const mainEl = this.closest('jeff-product-main') || document.querySelector('jeff-product-main');
        const price = mainEl ? parseInt(mainEl.querySelector('[data-jeff-price]')?.textContent?.replace(/\D/g, '') + '00', 10) : this.slots[1]?.price;

        this.slots[1] = {
          id: detail.ready ? detail.variantId : null,
          title: this.dataset.productTitle || '',
          variant: this.getSlot1VariantText(),
          price: price || this.slots[1]?.price || 0
        };

        const variantEl = this.querySelector('[data-slot-variant="1"]');
        if (variantEl) variantEl.textContent = this.slots[1].variant;

        this.calculateTierPrices();
        this.updateUI();
      };
      document.addEventListener('jeff:variant-change', this.variantListener);
    }

    disconnectedCallback() {
      if (this.variantListener) {
        document.removeEventListener('jeff:variant-change', this.variantListener);
      }
      if (this.modal?.dataset.comboModalOwner === this.id) {
        this.modal.remove();
      }
    }

    yieldToNextPaint(fn) {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => {
          setTimeout(fn, 0);
        });
      } else {
        setTimeout(fn, 0);
      }
    }

    initModalItems() {
      if (this.modalItemsInitialized) return;
      this.modalItemsInitialized = true;

      const modalScope = this.modal || this;
      modalScope.querySelectorAll('.jeff-combo-product-item').forEach(item => {
        const variantsDataEl = item.querySelector('[data-combo-variants]');
        let variants = [];
        if (variantsDataEl) {
          try {
            variants = JSON.parse(variantsDataEl.textContent);
          } catch (e) {
            console.error('Jeff Shoes: Error parsing combo item variants', e);
          }
        }

        const colorIdx = parseInt(item.dataset.colorIndex || '0', 10);
        const sizeIdx = parseInt(item.dataset.sizeIndex || '1', 10);

        const swatches = item.querySelectorAll('[data-combo-color]');
        const sizeButtons = item.querySelectorAll('[data-combo-size]');
        const chooseBtn = item.querySelector('[data-combo-select-btn]');
        const mainImg = item.querySelector('[data-combo-product-img]');
        const colorNameEl = item.querySelector('[data-combo-color-name]');
        const sizeNameEl = item.querySelector('[data-combo-size-name]');
        const productTitle = item.querySelector('.jeff-combo-product-item__title')?.textContent?.trim() || '';

        const hasColors = swatches.length > 0;
        const hasSizes = sizeButtons.length > 0;

        let selectedColor = item.dataset.initialColor || (hasColors ? swatches[0].dataset.comboColor : '');
        let selectedSize = '';
        let selectedVariant = null;

        const updateSizeAvailability = () => {
          if (!hasSizes) return;
          const cleanColor = (selectedColor || '').trim().toLowerCase();

          sizeButtons.forEach(btn => {
            const sizeVal = (btn.dataset.comboSize || '').trim();
            const cleanSize = sizeVal.toLowerCase();

            // Verificar si existe variante disponible con este color y esta talla
            const isAvail = variants.some(v => {
              if (!v.available) return false;
              const vOptions = v.options || [];
              const vColor = (vOptions[colorIdx] || '').trim().toLowerCase();
              const vSize = (vOptions[sizeIdx] || '').trim().toLowerCase();
              if (hasColors && vColor !== cleanColor) return false;
              return vSize === cleanSize;
            });

            btn.disabled = !isAvail;
            btn.classList.toggle('is-sold-out', !isAvail);
            btn.setAttribute('aria-disabled', !isAvail ? 'true' : 'false');
          });
        };

        const resolveVariant = () => {
          selectedVariant = null;
          const cleanColor = (selectedColor || '').trim().toLowerCase();
          const cleanSize = (selectedSize || '').trim().toLowerCase();

          if (hasColors && hasSizes) {
            if (cleanColor && cleanSize) {
              selectedVariant = variants.find(v => {
                const vOptions = v.options || [];
                const vColor = (vOptions[colorIdx] || '').trim().toLowerCase();
                const vSize = (vOptions[sizeIdx] || '').trim().toLowerCase();
                return vColor === cleanColor && vSize === cleanSize && v.available;
              }) || variants.find(v => {
                const vOptions = v.options || [];
                const vColor = (vOptions[colorIdx] || '').trim().toLowerCase();
                const vSize = (vOptions[sizeIdx] || '').trim().toLowerCase();
                return vColor === cleanColor && vSize === cleanSize;
              });
            }
          } else if (hasColors) {
            if (cleanColor) {
              selectedVariant = variants.find(v => {
                const vColor = (v.options?.[colorIdx] || '').trim().toLowerCase();
                return vColor === cleanColor && v.available;
              }) || variants.find(v => {
                const vColor = (v.options?.[colorIdx] || '').trim().toLowerCase();
                return vColor === cleanColor;
              });
            }
          } else if (hasSizes) {
            if (cleanSize) {
              selectedVariant = variants.find(v => {
                const vSize = (v.options?.[sizeIdx] || '').trim().toLowerCase();
                return vSize === cleanSize && v.available;
              }) || variants.find(v => {
                const vSize = (v.options?.[sizeIdx] || '').trim().toLowerCase();
                return vSize === cleanSize;
              });
            }
          } else {
            selectedVariant = variants[0] || null;
          }

          if (chooseBtn) {
            const isReady = Boolean(selectedVariant && selectedVariant.available && (!hasSizes || selectedSize) && (!hasColors || selectedColor));
            chooseBtn.disabled = !isReady;
            if (hasSizes && !selectedSize) {
              chooseBtn.textContent = 'Selecciona tu talla';
            } else if (selectedVariant && !selectedVariant.available) {
              chooseBtn.textContent = 'Agotado';
            } else {
              chooseBtn.textContent = 'Elegir este par';
            }
          }
        };

        // Eventos en miniaturas de color
        swatches.forEach(swatch => {
          swatch.addEventListener('click', (e) => {
            e.preventDefault();
            const color = swatch.dataset.comboColor;
            selectedColor = color;

            swatches.forEach(s => {
              s.classList.remove('is-selected');
              s.setAttribute('aria-checked', 'false');
            });
            swatch.classList.add('is-selected');
            swatch.setAttribute('aria-checked', 'true');

            if (colorNameEl) {
              colorNameEl.textContent = color;
            }

            const newImg = swatch.dataset.imageSrc;
            if (mainImg && newImg) {
              mainImg.src = newImg;
            }

            updateSizeAvailability();

            // Si la talla seleccionada quedó agotada en este nuevo color, deseleccionarla
            if (selectedSize) {
              const currentSizeBtn = Array.from(sizeButtons).find(b => b.dataset.comboSize === selectedSize);
              if (currentSizeBtn && currentSizeBtn.disabled) {
                selectedSize = '';
                sizeButtons.forEach(b => {
                  b.classList.remove('is-selected');
                  b.setAttribute('aria-checked', 'false');
                });
                if (sizeNameEl) sizeNameEl.textContent = 'Elige tu talla';
              }
            }

            resolveVariant();
          });
        });

        // Eventos en botones de talla
        sizeButtons.forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (btn.disabled || btn.classList.contains('is-sold-out')) return;

            const size = btn.dataset.comboSize;
            selectedSize = size;

            sizeButtons.forEach(b => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-checked', 'true');

            if (sizeNameEl) {
              sizeNameEl.textContent = size;
            }

            resolveVariant();
          });
        });

        // Inicializar disponibilidad y botón
        updateSizeAvailability();
        resolveVariant();

        // Botón Elegir este par
        if (chooseBtn) {
          chooseBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (!selectedVariant || !selectedVariant.available) return;

            const variantId = selectedVariant.id;
            const variantTitle = selectedVariant.title || `${selectedColor} / ${selectedSize}`;
            const price = selectedVariant.price || 0;
            const img = selectedVariant.featured_image?.src || mainImg?.src || '';
            const productHandle = item.dataset.handle;
            const productUrl = productHandle ? `/products/${productHandle}` : '#';

            this.assignSlot(this.activePickerSlot, {
              id: variantId,
              title: productTitle,
              variant: variantTitle,
              price: price,
              img: img,
              url: productUrl
            });

            this.closePickerModal();
          });
        }
      });
    }

    setTier(tier) {
      this.currentTier = tier;

      // 1. Immediate visual feedback (<10ms)
      this.tierButtons.forEach(btn => {
        const isSelected = parseInt(btn.dataset.tier, 10) === tier;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      // 2. Yield heavy DOM updates and calculations to next frame
      this.yieldToNextPaint(() => {
        const wrap2 = this.querySelector('[data-pair-slot-wrap="2"]');
        const wrap3 = this.querySelector('[data-pair-slot-wrap="3"]');
        if (wrap2) wrap2.hidden = tier < 2;
        if (wrap3) wrap3.hidden = tier < 3;

        if (this.actionWrap) {
          this.actionWrap.hidden = tier === 1;
        }

        this.calculateTierPrices();
        this.updateUI();

        if (tier >= 2 && !this.slots[2]?.id) {
          this.openPickerModal(2);
        } else if (tier === 3 && !this.slots[3]?.id) {
          this.openPickerModal(3);
        }
      });
    }

    openPickerModal(slotNumber) {
      this.initModalItems();
      this.activePickerSlot = slotNumber;
      if (!this.modal) return;
      this.lastPickerTrigger = document.activeElement;
      const titleEl = this.modal.querySelector('[data-combo-picker-title]');
      if (titleEl) {
        titleEl.textContent = slotNumber === 2 ? 'Elige tu segundo par' : 'Elige tu tercer par';
      }
      const pickerList = this.modal.querySelector('[data-combo-picker-list]');
      if (pickerList) pickerList.scrollTop = 0;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      this.previousBodyOverflow = document.body.style.overflow;
      this.previousBodyPosition = document.body.style.position;
      this.previousBodyTop = document.body.style.top;
      this.previousBodyLeft = document.body.style.left;
      this.previousBodyRight = document.body.style.right;
      this.previousBodyWidth = document.body.style.width;
      this.previousScrollY = window.scrollY;
      this.previousHtmlModalOpen = document.documentElement.classList.contains('jeff-modal-open');
      this.previousBodyModalOpen = document.body.classList.contains('jeff-modal-open');
      document.documentElement.classList.add('jeff-modal-open');
      document.body.classList.add('jeff-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.previousScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      const dialogContent = this.modal.querySelector('.jeff-modal__content');
      if (dialogContent) {
        requestAnimationFrame(() => dialogContent.focus({ preventScroll: true }));
      }
    }

    trapModalFocus(event) {
      const focusable = Array.from(
        this.modal.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => !element.hidden && element.getClientRects().length > 0);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closePickerModal() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = this.previousBodyOverflow;
      document.body.style.position = this.previousBodyPosition;
      document.body.style.top = this.previousBodyTop;
      document.body.style.left = this.previousBodyLeft;
      document.body.style.right = this.previousBodyRight;
      document.body.style.width = this.previousBodyWidth;
      if (!this.previousHtmlModalOpen) document.documentElement.classList.remove('jeff-modal-open');
      if (!this.previousBodyModalOpen) document.body.classList.remove('jeff-modal-open');
      window.scrollTo(0, this.previousScrollY);
      if (this.lastPickerTrigger && typeof this.lastPickerTrigger.focus === 'function') {
        this.lastPickerTrigger.focus({ preventScroll: true });
      }
      this.lastPickerTrigger = null;
    }

    assignSlot(slotNumber, data) {
      this.slots[slotNumber] = data;

      const wrap = this.querySelector(`[data-pair-slot-wrap="${slotNumber}"]`);
      if (!wrap) return;

      const addBtn = wrap.querySelector(`[data-pair-add="${slotNumber}"]`);
      const card = wrap.querySelector(`[data-pair-card="${slotNumber}"]`);
      const titleEl = wrap.querySelector(`[data-slot-title="${slotNumber}"]`);
      const titleLinkEl = wrap.querySelector(`[data-slot-title-link="${slotNumber}"]`);
      const thumbLinkEl = wrap.querySelector(`[data-slot-link="${slotNumber}"]`);
      const variantEl = wrap.querySelector(`[data-slot-variant="${slotNumber}"]`);
      const imgEl = wrap.querySelector(`[data-slot-img="${slotNumber}"]`);

      if (addBtn) addBtn.hidden = true;
      if (card) card.hidden = false;
      if (titleEl) titleEl.textContent = data.title;
      if (titleLinkEl && data.url) {
        titleLinkEl.href = data.url;
        titleLinkEl.setAttribute('aria-label', `Ver producto ${data.title} (se abre en nueva pestaña)`);
      }
      if (thumbLinkEl && data.url) {
        thumbLinkEl.href = data.url;
        thumbLinkEl.setAttribute('aria-label', `Ver producto ${data.title} (se abre en nueva pestaña)`);
      }
      if (variantEl) variantEl.textContent = data.variant;
      if (imgEl && data.img) imgEl.src = data.img;

      this.calculateTierPrices();
      this.updateUI();
    }

    parsePriceToCents(priceInput, fallbackCents) {
      if (!priceInput) return fallbackCents;
      if (typeof priceInput === 'number') {
        return priceInput > 1000000 ? priceInput : priceInput * 100;
      }
      const clean = String(priceInput).replace(/\D/g, '');
      if (!clean) return fallbackCents;
      const num = parseInt(clean, 10);
      if (isNaN(num) || num <= 0) return fallbackCents;
      // En pesos colombianos (ej: 145000 para $145.000 COP):
      // En centavos Shopify debe multiplicarse por 100 si num < 1.000.000
      if (num < 1000000) {
        return num * 100;
      }
      return num;
    }

    calculateTierPrices() {
      const p1 = this.slots[1]?.price || parseInt(this.dataset.currentPrice, 10) || 12000000;
      const p2 = this.slots[2]?.price || parseInt(this.dataset.suggestedPrice, 10) || p1;
      const p3 = this.slots[3]?.price || p2;

      // Tier 1
      const tier1PriceEl = this.querySelector('[data-tier-price="1"]');
      if (tier1PriceEl) tier1PriceEl.textContent = this.formatMoney(p1);

      // Tier 2 (Precio manual fijo)
      const reg2 = p1 + p2;
      const tot2 = this.parsePriceToCents(this.dataset.comboTwoPrice, Math.round(reg2 * 0.8));
      const sav2 = Math.max(0, reg2 - tot2);
      const customSaving2 = (this.dataset.comboTwoSaving || '').trim();

      const tier2PriceEl = this.querySelector('[data-tier-price="2"]');
      const tier2SavEl = this.querySelector('[data-tier-savings="2"]');
      if (tier2PriceEl) tier2PriceEl.textContent = this.formatMoney(tot2);
      if (tier2SavEl) {
        tier2SavEl.textContent = customSaving2 || (sav2 > 0 ? `Ahorras ${this.formatMoney(sav2)}` : '');
      }

      // Tier 3 (Precio manual fijo)
      const reg3 = p1 + p2 + p3;
      const tot3 = this.parsePriceToCents(this.dataset.comboThreePrice, Math.round(reg3 * 0.7));
      const sav3 = Math.max(0, reg3 - tot3);
      const customSaving3 = (this.dataset.comboThreeSaving || '').trim();

      const tier3PriceEl = this.querySelector('[data-tier-price="3"]');
      const tier3SavEl = this.querySelector('[data-tier-savings="3"]');
      if (tier3PriceEl) tier3PriceEl.textContent = this.formatMoney(tot3);
      if (tier3SavEl) {
        tier3SavEl.textContent = customSaving3 || (sav3 > 0 ? `Ahorras ${this.formatMoney(sav3)}` : '');
      }

      this.currentTotals = { 1: p1, 2: tot2, 3: tot3 };
    }

    updateUI() {
      if (this.feedbackEl) this.feedbackEl.textContent = '';

      if (this.currentTier === 1) {
        if (this.actionWrap) this.actionWrap.hidden = true;
        return;
      }

      if (this.actionWrap) this.actionWrap.hidden = false;

      // Check completeness for current tier
      const slot1Ready = Boolean(this.slots[1]?.id);
      const slot2Ready = Boolean(this.slots[2]?.id);
      const slot3Ready = Boolean(this.slots[3]?.id);

      let isReady = false;
      let missingMsg = '';

      if (this.currentTier === 2) {
        if (!slot1Ready) {
          missingMsg = 'Selecciona la talla de tu primer par arriba.';
        } else if (!slot2Ready) {
          missingMsg = 'Añade tu segundo par para completar el combo.';
        } else {
          isReady = true;
        }
      } else if (this.currentTier === 3) {
        if (!slot1Ready) {
          missingMsg = 'Selecciona la talla de tu primer par arriba.';
        } else if (!slot2Ready) {
          missingMsg = 'Añade tu segundo par para continuar.';
        } else if (!slot3Ready) {
          missingMsg = 'Añade tu tercer par para completar el combo.';
        } else {
          isReady = true;
        }
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = !slot1Ready;
        this.submitBtn.classList.toggle('is-ready', isReady);
      }

      if (this.submitText) {
        const totalAmount = this.currentTotals ? this.formatMoney(this.currentTotals[this.currentTier]) : '';
        if (isReady) {
          this.submitText.textContent = `AGREGAR ${this.currentTier} PARES AL CARRITO · ${totalAmount}`;
        } else {
          this.submitText.textContent = missingMsg || 'COMPLETAR SELECCIÓN';
        }
      }
    }

    async handleComboSubmit(e) {
      e.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const itemsToAdd = [];
      if (this.slots[1]?.id) itemsToAdd.push({ id: this.slots[1].id, quantity: 1 });
      if (this.currentTier >= 2 && this.slots[2]?.id) itemsToAdd.push({ id: this.slots[2].id, quantity: 1 });
      if (this.currentTier === 3 && this.slots[3]?.id) itemsToAdd.push({ id: this.slots[3].id, quantity: 1 });

      if (itemsToAdd.length < this.currentTier) {
        if (this.feedbackEl) this.feedbackEl.textContent = 'Por favor completa la selección de todos los pares.';
        return;
      }

      const originalText = this.submitText ? this.submitText.textContent : '';
      this.submitBtn.disabled = true;
      if (this.submitText) this.submitText.textContent = 'AGREGANDO TUS PARES...';

      const drawer = document.querySelector('cart-drawer');
      const root = window.Shopify?.routes?.root || '/';

      try {
        const payload = { items: itemsToAdd };
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map(s => s.id);
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || 'No se pudieron agregar los productos al carrito.');
        }

        if (drawer) {
          if (window.jeffRenderCartDrawer) {
            await window.jeffRenderCartDrawer(drawer, data);
          } else {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          }
        } else {
          window.location.assign(root + 'cart');
        }

        if (this.submitText) this.submitText.textContent = '¡PARES AGREGADOS!';
        setTimeout(() => {
          this.submitBtn.disabled = false;
          this.updateUI();
        }, 2500);

      } catch (err) {
        console.error('Jeff Shoes: Error agregando combo', err);
        if (this.feedbackEl) this.feedbackEl.textContent = err.message || 'Error al agregar los pares.';
        this.submitBtn.disabled = false;
        if (this.submitText) this.submitText.textContent = originalText;
      }
    }

    formatMoney(cents) {
      const amount = typeof cents === 'number' ? cents / 100 : 0;
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', {
        style: 'currency',
        currency: this.dataset.currency || 'COP',
        maximumFractionDigits: 0
      }).format(amount);
    }
  }

  customElements.define('jeff-pair-combo', JeffPairCombo);
})();
